var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3.3418C11.7441 3.3418 11.4885 3.44122 11.293 3.63672L5.63672 9.29297C5.24572 9.68297 5.24572 10.316 5.63672 10.707L5.72266 10.793C6.11266 11.184 6.74572 11.184 7.13672 10.793L11 6.92969V20C11 20.552 11.448 21 12 21C12.552 21 13 20.552 13 20V6.92969L16.8633 10.793C17.2533 11.184 17.8863 11.184 18.2773 10.793L18.3633 10.707C18.7543 10.317 18.7543 9.68397 18.3633 9.29297L12.707 3.63672C12.512 3.44122 12.2559 3.3418 12 3.3418Z"
  })));
}
export default SvgArrowUpreact;